/* script */
//
//
//
//
//
//
//
//
//
//
//

// Utils
import { mixin as clickaway } from 'vue-clickaway';

const VALID_ANCHOR_POS_PROP_VALUES = ['nw', 'ne', 'sw', 'se'];

/**
 * Dropdown component, used to display a contextual menu.
 *
 * @example
 * DropdownMenu
 *   ul
 *       li
 *           a(href="#") My menu item
 *
 * @vue-prop {String} [anchorPos='nw']
 *
 * @category ui.components
 * @exports DropdownMenu
 * @component
 */
const __vue_script__ = {
    name: 'DropdownMenu',

    mixins: [clickaway],

    props: {
        anchorPos: {
            type: String,
            validator: (value) => VALID_ANCHOR_POS_PROP_VALUES.indexOf(value) !== -1,
            default: 'ne'
        },

        disabled: {
            type: Boolean,
            default: false
        },

        hideDelayAfterClick: {
            type: Number,
            default: 500
        },

        ariaLabel: {
            type: String,
            default: '',
        },

        startOpen: {
            type: Boolean,
            default: false
        },

        boundingElement: {
            type: HTMLElement,
            default: null
        },

        forcePosition: {
            type: Boolean,
            default: false
        }
    },

    data() {
        return {
            calculatedAnchor: '',
            isShown: false,
            menuReady: false,
            noScrolls: false
        };
    },

    computed: {
        isInModal() {
            return Boolean(this.$el.closest('.modal-wrapper'));
        }
    },

    mounted() {
        this.handler = ({ detail }) => {
            if (detail.id !== this._uid) {
                this.hide();
            }
        };


        window.addEventListener('dropdown-open', this.handler);

        if (this.startOpen) {
            this.show();
        }
    },

    beforeDestroy() {
        window.removeEventListener('dropdown-open', this.handler);
    },

    methods: {
        toggle() {
            if (this.isShown) {
                this.hide();
            } else {
                this.show();
            }

            this.$emit('activator-click', this.isShown);
        },

        /**
         * Shows the drodpdown
         */
        show() {
            if (this.disabled) return;
            // We need to calculate this position before the menu is appended to the dom. Otherwise it's taken into account in the scroll parent calculation.
            // @ts-ignore
            const scrollableParent = this.$utils.dom.getScrollParent(this.$refs.dropdown);
            this.noScrolls = this.isInModal && scrollableParent.tagName === 'HTML';
            const parent = this.boundingElement || scrollableParent;
            const parentBoundingRect = parent.getBoundingClientRect();
            this.isShown = true;

            // We calculate the anchor in the next tick in order
            // to allow vue the time to append the menu to the DOM
            this.$nextTick(() => this.calculateAnchor(parentBoundingRect));

            const event = new CustomEvent('dropdown-open', { detail: { id: this._uid } });
            window.dispatchEvent(event);
        },

        /**
         * Click-away handler.
         */
        away() {
            this.hide(0, true);
        },

        /**
         * Hides the drodpdown
         *
         * @param {Number} [delay=0] number of milliseconds to wait before hiding
         * @param {Boolean} [away=false] whether the hide was called from away or within the menu
         */
        hide(delay = 0, away = false) {
            if (delay < 0) {
                return;
            }
            setTimeout(() => {
                this.isShown = false;
                this.menuReady = false;
                // Next tick to prevent flickering
                this.$nextTick(() => {
                    this.calculatedAnchor = this.anchorPos;
                    if (away) {
                        this.$emit('away');
                    }
                });
            }, delay);
        },

        /**
         * Calculates the anchor of the menu according to the surrounding elements
         *
         * @param {Object} parentBoundingRect bounding rect for the dropdown scroll parent.
         */
        calculateAnchor(parentBoundingRect) {
            if (this.isInModal || this.forcePosition) {
                this.calculatedAnchor = this.anchorPos;
                this.menuReady = true;
                return;
            }

            // @ts-ignore
            const menuBoundingRect = this.$refs.menu.getBoundingClientRect();

            let newAnchor = '';
            // If bottom would be below what's possible we force the dropdown to be on top
            if (menuBoundingRect.bottom > parentBoundingRect.bottom) {
                newAnchor += 's';
            } else {
                newAnchor += this.anchorPos[0];
            }

            // If the drop down is going to far right, we force the drop down to be bound on the east.
            if (menuBoundingRect.right > parentBoundingRect.right) {
                newAnchor += 'e';
            } else {
                newAnchor += this.anchorPos[1];
            }

            this.calculatedAnchor = newAnchor;
            this.menuReady = true;
        }
    }
};

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"dropdown",staticClass:"dropdown",class:[_vm.isShown ? 'in' : '', _vm.noScrolls ? 'safe-position' : '']},[_c('div',{staticClass:"activator",attrs:{"disabled":_vm.disabled,"aria-label":_vm.ariaLabel},on:{"click":function($event){$event.stopPropagation();$event.preventDefault();return _vm.toggle.apply(null, arguments)}}},[_vm._t("toggler",function(){return [_c('button',{staticClass:"btn default",attrs:{"type":"button","disabled":_vm.disabled}},[_c('i',{staticClass:"icon-dots-three-vertical"})])]})],2),_c('div',{staticClass:"menu-wrapper"},[(_vm.isShown)?_c('div',{directives:[{name:"on-clickaway",rawName:"v-on-clickaway",value:(_vm.away),expression:"away"}],ref:"menu",staticClass:"menu dropdown-vue",class:['anchor-' + _vm.calculatedAnchor, _vm.menuReady ? 'visible' : ''],on:{"click":function($event){return _vm.hide(_vm.hideDelayAfterClick)}}},[_vm._t("default")],2):_vm._e()])])}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "DropdownMenu.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__